import { inject } from '@app/app-injector';
import { collectDatadogLogs } from '@utils/collect-datadog-logs';

collectDatadogLogs();

inject('#root', {
  hostingBasePath: import.meta.env.BASE_URL,
  routingBasePath: import.meta.env.BASE_URL,
});
